import React, { Component } from "react";
import { connect } from "react-redux";
import { orderBy } from "../actions";
import { ORDER_ASC, ORDER_DESC } from "../shared/constants";

class FlightsHeaderWrapper extends Component {
	isSelectedColumn(selectedColumn) {
		const currentColumn = this.props.columnOrderBy[this.props.currentStretch].column;
		const currentColumnOrder = this.props.columnOrderBy[this.props.currentStretch].order;
		return selectedColumn == currentColumn && currentColumnOrder == ORDER_DESC;
	}

	render() {
		const currentStretch = this.props.currentStretch;
		const selectedColumn = this.props.columnOrderBy[currentStretch].column;

		return (
			<div className="header-flights">
				<div className="container-fluid">
					<div className="row">
						<div className="col-xs-16 col-md-12 flight-list-heading no-padding">
							<div className="container-fluid no-padding">
								<div className="row row-eq-heights no-margin">
									<div className="col-xs-4 col-md-4 no-padding">
										<label>Companhia</label>
									</div>
									<div
										data-action="order-by-departure-date"
										className="col-xs-4 col-md-4 order-by"
										onClick={() => {
											this.props.orderBy("departureDate", currentStretch);
										}}
									>
										<label className={selectedColumn === "departureDate" ? "active-order" : ""}>
											Partida{" "}
											<i
												className={
													this.isSelectedColumn("departureDate")
														? "icon-arrow-up"
														: "icon-arrow-down"
												}
												aria-hidden="true"
											/>
										</label>
									</div>
									<div
										data-action="order-by-duration"
										className="col-xs-4 col-md-4 order-by no-padding"
										onClick={() => {
											this.props.orderBy("duration", currentStretch);
										}}
									>
										<label className={selectedColumn === "duration" ? "active-order" : ""}>
											Duração{" "}
											<i
												className={
													this.isSelectedColumn("duration") ? "icon-arrow-up" : "icon-arrow-down"
												}
												aria-hidden="true"
											/>
										</label>
									</div>
									<div
										data-action="order-by-arrival-date"
										className="col-xs-4 col-md-4 order-by"
										onClick={() => {
											this.props.orderBy("arrivalDate", currentStretch);
										}}
									>
										<label className={selectedColumn === "arrivalDate" ? "active-order" : ""}>
											Chegada{" "}
											<i
												className={
													this.isSelectedColumn("arrivalDate") ? "icon-arrow-up" : "icon-arrow-down"
												}
												aria-hidden="true"
											/>
										</label>
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-4 flight-list-h--price no-padding hidden-xs hidden-sm">
							<div className="container-fluid">
								<div className="row row-eq-heights">
									<div
										data-action="order-by-show-price"
										className="col-xs-16 order-by"
										onClick={() => {
											this.props.orderBy("showPrice", currentStretch);
										}}
									>
										<label className={selectedColumn === "showPrice" ? "active-order" : ""}>
											Preço{" "}
											<i
												className={
													this.isSelectedColumn("showPrice") ? "icon-arrow-up" : "icon-arrow-down"
												}
												aria-hidden="true"
											/>
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	selectedFlights: state.selectedFlights,
	currentStretch: state.flightsTab.currentStretch,
	columnOrderBy: state.flights.orderBy,
	isShowingMilesQuantity: state.flights.showMilesQuantity
});

const mapDispatchToProps = dispatch => ({
	orderBy: (column, stretch) => dispatch(orderBy(column, stretch))
});

export default connect(mapStateToProps, mapDispatchToProps)(FlightsHeaderWrapper);
